<template>
  <div>
    <div class="card">
      <div class="card-header">
        <a-form :form="form" layout="inline">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-xl-7">
                  <div class="row">
                    <div class="col-md-9 offset-md-4">
                      <a-form-item
                        :label-col="labelCol"
                        :wrapper-col="wrapperCol"
                        style="width: 360px"
                        :label="$t('Keyword')"
                      >
                        <a-input
                          :placeholder="$t('Keyword')"
                          v-decorator="[
                            'keyword',
                            {
                              initialValue: '',
                              rules: [
                                {
                                  required: false,
                                  message: '',
                                },
                              ],
                            },
                          ]"
                          @pressEnter="handleFilter"
                        />
                      </a-form-item>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5">
                  <div class="col-md-10">
                    <a-button
                      type="button"
                      class="btn btn-primary mt-1 mb-1"
                      @click="handleFilter"
                      :loading="searching"
                    >
                      {{ $t('Search') }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-form>
        <div style="text-align: right">
          <a-button
            type="button"
            class="btn btn-success mt-1 mb-1"
            @click="handleActionManage"
          >
            + {{ $t('Add') }}
          </a-button>
          <a-button
            type="button"
            class="btn btn-danger mt-1 mb-1"
            style="margin-left: 1rem"
            @click="onDelete"
            :loading="deleting"
          >
            - {{ $t('Delete') }}
          </a-button>
        </div>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :dataSource="data"
          :pagination="false"
          :locale="table_locale"
          :loading="searching"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          rowKey="procurement_step_id"
        >
          <span slot="sort_order" slot-scope="text, record, index">
            <sort-order
              :result_data="data"
              rowKey="procurement_step_id"
              :rowData="record"
              :rowIndex="index"
              @on-switch-orders="onSwitchOrders"
            />
          </span>
          <!-- <span slot="step" slot-scope="text, record">
            <a-button
              size="small"
              type="btn-info"
              class="mr-1"
              @click="handleAction(record.procurement_step_id)"
            >
              + {{ $t('Add/Edit') }}
            </a-button>
          </span> -->
          <span slot="manage" slot-scope="text, record">
            <a-button
              size="small"
              type="primary"
              class="mr-1"
              @click="handleActionManage(record.procurement_step_id)"
            >
              {{ $t('Edit') }}
            </a-button>
          </span>
        </a-table>
        <div class="col-md-12" style="padding: 1.33rem 0">
          <a-pagination
            v-model="current_page"
            :total="last_page"
            @change="handleFilter"
          />
        </div>
        <modal-form-procurement-step
          ref="modalForm"
          :visible="visible"
          :data_by_id="data_by_id"
          @on-save="onSave"
          @on-cancel="onCancel"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import SortOrder from './../../../components/datatable/datatableSortOrder';
import modalFormProcurementStep from './modalFormProcurementStep';
const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
};
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 20 },
};
export default {
  components: {
    SortOrder,
    modalFormProcurementStep,
  },
  data: function () {
    const columns = [
      {
        title: '#',
        dataIndex: 'row_number',
        scopedSlots: { customRender: 'row_number' },
      },
      {
        title: this.$t('Order Manage'),
        key: 'sort_order',
        align: 'center',
        scopedSlots: {
          customRender: 'sort_order',
        },
      },
      {
        title: this.$t('Procurement Step Name'),
        dataIndex: 'name',
      },
      {
        title: this.$t('Status'),
        dataIndex: 'status',
        align: 'center',
        scopedSlots: { customRender: 'status' },
        sorter: (a, b) => a.status - b.status,
      },
      {
        title: this.$t('Step'),
        dataIndex: 'step',
        align: 'center',
        scopedSlots: { customRender: 'step' },
        sorter: (a, b) => a.step - b.step,
      },
      {
        title: this.$t('Manage'),
        dataIndex: 'manage',
        align: 'center',
        scopedSlots: { customRender: 'manage' },
      },
    ];
    return {
      form: this.$form.createForm(this),
      searching: false,
      deleting: false,
      visible: false,
      current_page: 1,
      last_page: 1,
      columns,
      labelCol,
      wrapperCol,
      data: '',
      data_by_id: '',
      procurement_id: this.$route.params.id,
      table_locale: {
        filterConfirm: this.$t('Ok'),
        filterReset: this.$t('Reset'),
        emptyText: this.$t('No Data'),
      },
      selectedRowKeys: [],
    };
  },
  mounted() {
    this.handleFilter();
  },
  methods: {
    handleFilter(current_page = null) {
      if (typeof current_page != 'number') current_page = this.current_page;
      this.form.validateFields((err, values) => {
        if (!err) {
          this.searching = true;
          this.$store.dispatch('user/POST', {
            payload: {
              path: 'api/console/procurements/' + this.procurement_id + '/edit',
              data: {
                pageNo: current_page,
                itemPerPage: 20,
                ...values,
              },
              callback: (res) => {
                console.log('res.data', res.data.item.step_data.data);
                if (
                  res &&
                  res.data &&
                  res.data.item &&
                  res.data.item.step_data &&
                  res.data.item.step_data.data
                ) {
                  if (res.current_page) this.current_page = res.current_page;
                  if (res.last_page) this.last_page = res.last_page * 10;
                  if (_.isArray(res.data.item.step_data.data)) {
                    this.data = _.filter(
                      res.data.item.step_data.data,
                      (v, k) =>
                        (v.row_number =
                          (this.current_page > 1
                            ? 20 * (this.current_page - 1)
                            : 0) +
                          k +
                          1)
                    );
                    console.log('this.data', this.data);
                  }
                }
                this.searching = false;
              },
            },
          });
        }
      });
    },
    handleActionManage(procurement_step_id) {
      this.searching = true;
      if (Number(procurement_step_id)) {
        this.$store.dispatch('user/GET', {
          payload: {
            path:
              '/api/console/procurements_step/' + procurement_step_id + '/edit',
            callback: (res) => {
              if (res && !_.isEmpty(res.data)) {
                this.searching = false;
                this.data_by_id = res.data;
                this.visible = true;
              }
            },
          },
        });
      } else {
        this.searching = false;
        this.visible = true;
      }
    },
    onSwitchOrders({ dataOrder }) {
      const self = this;
      dataOrder.forEach((d) => {
        self.$store.dispatch('user/POST', {
          payload: {
            path: `/api/console/procurements_step/${d.id}/edit`,
            data: {
              sort_order: d.sort_order,
              procurement_id: this.procurement_id,
            },
            callback: (res) => {
              if (res && res.success) {
                self.handleFilter();
              }
            },
          },
        });
      });
    },
    onSave() {
      const form = this.$refs.modalForm.form;
      form.validateFields((err, values) => {
        if (!err) {
          values.procurement_id = this.procurement_id;
          this.visible = false;
          const form = this.$refs.modalForm.form;
          form.resetFields();
          this.searching = true;
          var url = '';
          if (this.data_by_id) {
            url =
              '/api/console/procurements_step/' +
              this.data_by_id.procurement_step_id +
              '/edit';
          } else {
            url = '/api/console/procurements_step/add';
          }
          this.$store.dispatch('user/POST', {
            payload: {
              path: url,
              data: values,
              callback: (res) => {
                if (res && res.success) {
                  this.handleFilter();
                } else {
                  const error = {
                    message: this.$t('Save Fail!'),
                  };
                  _.filter(res.error, (v, k) => {
                    if (k == 0) {
                      error.description = v;
                    } else {
                      error.description += ', ' + v;
                    }
                  });
                  this.$notification.error(error);
                }
                this.searching = false;
              },
            },
          });
        }
      });
    },
    onDelete() {
      var self = this;
      const selectedTo = this.selectedRowKeys;
      if (selectedTo.length == 0) {
        this.$api.dialog.alert('Please select item for delete');
      } else {
        this.$api.dialog
          .confirm('Do you Want to delete these items?')
          .then((confirm) => {
            if (confirm) {
              self.searching = true;
              Promise.all(
                selectedTo.map((id) => {
                  var deleteUrl = this.$api.helper.replace(
                    '/api/console/procurements_step/{id}/delete',
                    {
                      id,
                    }
                  );
                  return self.$store.dispatch('user/GET', {
                    payload: {
                      path: deleteUrl,
                    },
                  });
                })
              )
                .then((res) => {
                  setTimeout(() => {
                    this.handleFilter();
                    self.searching = false;
                  }, 2000);
                })
                .catch((err) => {
                  this.$api.dialog.axiosError(err);
                });
            }
          });
      }
    },
    onCancel() {
      this.visible = false;
      const form = this.$refs.modalForm.form;
      form.resetFields();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
};
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
